var map = {
	"./BOTChallenge.svg": "dab2",
	"./CoronaRedirect.jpg": "ee0c",
	"./Gallop-TV.svg": "f4ff",
	"./Grooms-Init.svg": "14ea",
	"./PDFIcon.svg": "bd0a",
	"./SaddleCloth SVGs/saddle-cloths-1.svg": "d969",
	"./SaddleCloth SVGs/saddle-cloths-10.svg": "4cf1",
	"./SaddleCloth SVGs/saddle-cloths-11.svg": "f972",
	"./SaddleCloth SVGs/saddle-cloths-12.svg": "c03c",
	"./SaddleCloth SVGs/saddle-cloths-13.svg": "73ab",
	"./SaddleCloth SVGs/saddle-cloths-14.svg": "19a0",
	"./SaddleCloth SVGs/saddle-cloths-15.svg": "5d85",
	"./SaddleCloth SVGs/saddle-cloths-16.svg": "1cbe",
	"./SaddleCloth SVGs/saddle-cloths-17.svg": "7e57",
	"./SaddleCloth SVGs/saddle-cloths-18.svg": "dbab",
	"./SaddleCloth SVGs/saddle-cloths-19.svg": "65d7",
	"./SaddleCloth SVGs/saddle-cloths-2.svg": "08a5",
	"./SaddleCloth SVGs/saddle-cloths-20.svg": "150f",
	"./SaddleCloth SVGs/saddle-cloths-3.svg": "4cd6",
	"./SaddleCloth SVGs/saddle-cloths-4.svg": "1bb8",
	"./SaddleCloth SVGs/saddle-cloths-5.svg": "e894",
	"./SaddleCloth SVGs/saddle-cloths-6.svg": "1062",
	"./SaddleCloth SVGs/saddle-cloths-7.svg": "e56c",
	"./SaddleCloth SVGs/saddle-cloths-8.svg": "3468",
	"./SaddleCloth SVGs/saddle-cloths-9.svg": "adc3",
	"./Summer-Challenge.svg": "b00f",
	"./Winning Form - Copy-01.svg": "6b50",
	"./YouTube.svg": "4a5f",
	"./arrow-white-down.svg": "5ed8",
	"./arrow-white-up.svg": "fe9b",
	"./bell.svg": "3845",
	"./card_changes-icon.svg": "3b11",
	"./close-icon-white.svg": "1107",
	"./close-icon.svg": "9b7f",
	"./facebook-icon.svg": "d4fd",
	"./fairviewRaceCourse_BG.jpg": "316d",
	"./fixtures-background.jpg": "adb8",
	"./fixtures-dropdown-icon.svg": "fbf0",
	"./hollywood-icon.svg": "7660",
	"./hollywoodSilk.png": "4731",
	"./horse-tips-redirect.svg": "db54",
	"./instagram-icon.svg": "aabc",
	"./login-background.jpg": "e23e2",
	"./logo-TNC.svg": "5d91",
	"./magic-tips-icon.svg": "1319",
	"./mail-icon.svg": "d26f",
	"./old-site-selector-menu.svg": "a985",
	"./printer.svg": "75d6",
	"./racecard-icon.svg": "3c53",
	"./racecourse-barrowdalePark-turf-1000.svg": "f7de",
	"./racecourse-barrowdalePark-turf-1100.svg": "7077",
	"./racecourse-barrowdalePark-turf-1200.svg": "23e4",
	"./racecourse-barrowdalePark-turf-1260.svg": "1587",
	"./racecourse-barrowdalePark-turf-1450.svg": "2394",
	"./racecourse-barrowdalePark-turf-1600.svg": "a37c",
	"./racecourse-barrowdalePark-turf-1700.svg": "2a72",
	"./racecourse-barrowdalePark-turf-1800.svg": "0db7",
	"./racecourse-barrowdalePark-turf-1900.svg": "8fd9",
	"./racecourse-barrowdalePark-turf-2000.svg": "aaa4",
	"./racecourse-barrowdalePark-turf-2200.svg": "4b3b",
	"./racecourse-barrowdalePark-turf-2400.svg": "68ee",
	"./racecourse-barrowdalePark-turf-2700.svg": "c06f",
	"./racecourse-barrowdalePark-turf-600.svg": "1bf6",
	"./racecourse-barrowdalePark-turf-900.svg": "1ce7",
	"./racecourse-barrowdalePark-turf.svg": "a2d1",
	"./racecourse-durbanville-turf-1000.svg": "3918",
	"./racecourse-durbanville-turf-1200.svg": "fd8d",
	"./racecourse-durbanville-turf-1250.svg": "99d0",
	"./racecourse-durbanville-turf-1300.svg": "8344",
	"./racecourse-durbanville-turf-1400.svg": "f914",
	"./racecourse-durbanville-turf-1500.svg": "bb77",
	"./racecourse-durbanville-turf-1600.svg": "16e3",
	"./racecourse-durbanville-turf-1800.svg": "59df",
	"./racecourse-durbanville-turf-2000.svg": "83a9",
	"./racecourse-durbanville-turf-2400.svg": "7931",
	"./racecourse-durbanville-turf-3000.svg": "44c6",
	"./racecourse-durbanville-turf.svg": "f0a1",
	"./racecourse-fairview-poly-1000.svg": "727b",
	"./racecourse-fairview-poly-1100.svg": "36b9",
	"./racecourse-fairview-poly-1200.svg": "0859",
	"./racecourse-fairview-poly-1300.svg": "86bf",
	"./racecourse-fairview-poly-1400.svg": "c727",
	"./racecourse-fairview-poly-1600.svg": "dcad",
	"./racecourse-fairview-poly-1800.svg": "2ad3",
	"./racecourse-fairview-poly-1900.svg": "8828",
	"./racecourse-fairview-poly-2000.svg": "b3a8",
	"./racecourse-fairview-poly-2200.svg": "86dd",
	"./racecourse-fairview-poly-3150.svg": "febd",
	"./racecourse-fairview-poly-800.svg": "5e97",
	"./racecourse-fairview-poly-900.svg": "dca9",
	"./racecourse-fairview-poly.svg": "fbd9",
	"./racecourse-fairview-turf-1000.svg": "0006",
	"./racecourse-fairview-turf-1100.svg": "b9de",
	"./racecourse-fairview-turf-1200.svg": "0fb0",
	"./racecourse-fairview-turf-1300.svg": "3f64",
	"./racecourse-fairview-turf-1400.svg": "f2cf",
	"./racecourse-fairview-turf-1600.svg": "4fc7",
	"./racecourse-fairview-turf-1800.svg": "8640",
	"./racecourse-fairview-turf-1900.svg": "f194",
	"./racecourse-fairview-turf-2000.svg": "e485",
	"./racecourse-fairview-turf-2200.svg": "deba",
	"./racecourse-fairview-turf-2400.svg": "d689",
	"./racecourse-fairview-turf-2700.svg": "562e",
	"./racecourse-fairview-turf-2800.svg": "8d70",
	"./racecourse-fairview-turf-3200.svg": "da3b",
	"./racecourse-fairview-turf-3600.svg": "dc9f",
	"./racecourse-fairview-turf-800.svg": "ee17",
	"./racecourse-fairview-turf.svg": "dcf1",
	"./racecourse-flamingoPark-sand-1000.svg": "1d54",
	"./racecourse-flamingoPark-sand-1200.svg": "a1bb",
	"./racecourse-flamingoPark-sand-1300.svg": "edd5",
	"./racecourse-flamingoPark-sand-1400.svg": "6a94",
	"./racecourse-flamingoPark-sand-1600.svg": "636e",
	"./racecourse-flamingoPark-sand-1800.svg": "49b3",
	"./racecourse-flamingoPark-sand-2000.svg": "0fd3",
	"./racecourse-flamingoPark-sand-2200.svg": "3861",
	"./racecourse-flamingoPark-sand-800.svg": "e75d",
	"./racecourse-flamingoPark-sand.svg": "6ab8",
	"./racecourse-greyville-poly-1000.svg": "e526",
	"./racecourse-greyville-poly-1100.svg": "e261",
	"./racecourse-greyville-poly-1200.svg": "a7f1",
	"./racecourse-greyville-poly-1400.svg": "5232",
	"./racecourse-greyville-poly-1600.svg": "1c2a",
	"./racecourse-greyville-poly-1700.svg": "ee34",
	"./racecourse-greyville-poly-1800.svg": "a75c",
	"./racecourse-greyville-poly-1900.svg": "b4d0",
	"./racecourse-greyville-poly-1950.svg": "c11d",
	"./racecourse-greyville-poly-2000.svg": "8e86",
	"./racecourse-greyville-poly-2200.svg": "31fa",
	"./racecourse-greyville-poly-2400.svg": "5524",
	"./racecourse-greyville-poly-400.svg": "cd40",
	"./racecourse-greyville-poly.svg": "cc23",
	"./racecourse-greyville-turf-1000.svg": "c873",
	"./racecourse-greyville-turf-1100.svg": "0a3e",
	"./racecourse-greyville-turf-1200.svg": "a3a1",
	"./racecourse-greyville-turf-1300.svg": "1c8d",
	"./racecourse-greyville-turf-1400.svg": "8512",
	"./racecourse-greyville-turf-1600.svg": "5d8e",
	"./racecourse-greyville-turf-1700.svg": "626e",
	"./racecourse-greyville-turf-1800-48.svg": "288e",
	"./racecourse-greyville-turf-1800-49.svg": "9771",
	"./racecourse-greyville-turf-1800.svg": "7ec6",
	"./racecourse-greyville-turf-1900.svg": "41bd",
	"./racecourse-greyville-turf-2000.svg": "4cf5",
	"./racecourse-greyville-turf-2200.svg": "1d24",
	"./racecourse-greyville-turf-2400.svg": "2196",
	"./racecourse-greyville-turf-3000.svg": "af18",
	"./racecourse-greyville-turf-3200.svg": "9a0d",
	"./racecourse-greyville-turf-400.svg": "4c4b",
	"./racecourse-greyville-turf-800.svg": "71f4",
	"./racecourse-greyville-turf.svg": "30b5",
	"./racecourse-icon.svg": "3e88",
	"./racecourse-kenilworth-turf-1000.svg": "bd0d",
	"./racecourse-kenilworth-turf-1100.svg": "2100",
	"./racecourse-kenilworth-turf-1200.svg": "e38a",
	"./racecourse-kenilworth-turf-1250.svg": "797e",
	"./racecourse-kenilworth-turf-1400.svg": "39cc",
	"./racecourse-kenilworth-turf-1500.svg": "b5b7",
	"./racecourse-kenilworth-turf-1600.svg": "848f",
	"./racecourse-kenilworth-turf-1700.svg": "d2ac",
	"./racecourse-kenilworth-turf-1750.svg": "346b",
	"./racecourse-kenilworth-turf-1800.svg": "f46e",
	"./racecourse-kenilworth-turf-1900.svg": "101d",
	"./racecourse-kenilworth-turf-1950.svg": "69a7",
	"./racecourse-kenilworth-turf-2000.svg": "5a76",
	"./racecourse-kenilworth-turf-2200.svg": "ce53",
	"./racecourse-kenilworth-turf-2400.svg": "274c",
	"./racecourse-kenilworth-turf-2500.svg": "116f",
	"./racecourse-kenilworth-turf-2700.svg": "bba6",
	"./racecourse-kenilworth-turf-2800.svg": "08be",
	"./racecourse-kenilworth-turf-3200.svg": "1152",
	"./racecourse-kenilworth-turf-800.svg": "da25",
	"./racecourse-kenilworth-turf-900.svg": "c116",
	"./racecourse-kenilworth-turf-summer-1200.svg": "948e",
	"./racecourse-kenilworth-turf-summer-1300.svg": "174a",
	"./racecourse-kenilworth-turf-summer-1400.svg": "55f5",
	"./racecourse-kenilworth-turf-summer-1500.svg": "9e66",
	"./racecourse-kenilworth-turf-summer-1600.svg": "915a",
	"./racecourse-kenilworth-turf-summer-1700.svg": "c5b3",
	"./racecourse-kenilworth-turf-summer-1800.svg": "dc24",
	"./racecourse-kenilworth-turf-summer-1900.svg": "79ec",
	"./racecourse-kenilworth-turf-summer-2000.svg": "787c",
	"./racecourse-kenilworth-turf-summer-2200.svg": "24ec",
	"./racecourse-kenilworth-turf-summer-2400.svg": "36ce",
	"./racecourse-kenilworth-turf-summer-2500.svg": "1df7",
	"./racecourse-kenilworth-turf-summer-2700.svg": "5309",
	"./racecourse-kenilworth-turf-summer-2800.svg": "b575",
	"./racecourse-kenilworth-turf-summer-3200.svg": "9716",
	"./racecourse-kenilworth-turf-winter-1400.svg": "23dc",
	"./racecourse-kenilworth-turf-winter-1500.svg": "76c3",
	"./racecourse-kenilworth-turf-winter-1600.svg": "6ce6",
	"./racecourse-kenilworth-turf-winter-1700.svg": "5856",
	"./racecourse-kenilworth-turf-winter-1800.svg": "dfd7",
	"./racecourse-kenilworth-turf-winter-1900.svg": "3818",
	"./racecourse-kenilworth-turf-winter-2000.svg": "34bb",
	"./racecourse-kenilworth-turf-winter-2200.svg": "bdf5",
	"./racecourse-kenilworth-turf-winter-2400.svg": "8322",
	"./racecourse-kenilworth-turf-winter-2500.svg": "c6a6",
	"./racecourse-kenilworth-turf-winter-2600.svg": "90b2",
	"./racecourse-kenilworth-turf-winter-2700.svg": "fff9",
	"./racecourse-kenilworth-turf-winter-2800.svg": "3247",
	"./racecourse-kenilworth-turf-winter-3200.svg": "a7bd",
	"./racecourse-kenilworth-turf.svg": "ff07",
	"./racecourse-mauritius-turf-1250.svg": "5545",
	"./racecourse-mauritius-turf-1325.svg": "2360",
	"./racecourse-mauritius-turf-1365.svg": "a5d3",
	"./racecourse-mauritius-turf-1400.svg": "9e59",
	"./racecourse-mauritius-turf-1500.svg": "16c0",
	"./racecourse-mauritius-turf-1600.svg": "9eba",
	"./racecourse-mauritius-turf-1800.svg": "8d25",
	"./racecourse-mauritius-turf-2000.svg": "592e",
	"./racecourse-mauritius-turf-2100.svg": "bcc4",
	"./racecourse-mauritius-turf-2200.svg": "aae8",
	"./racecourse-mauritius-turf-2400.svg": "c371",
	"./racecourse-mauritius-turf.svg": "6cc6",
	"./racecourse-scottsville-turf-inner-1000.svg": "d395",
	"./racecourse-scottsville-turf-inner-1200.svg": "61aa",
	"./racecourse-scottsville-turf-inner-1400.svg": "e789",
	"./racecourse-scottsville-turf-inner-1500.svg": "6d5d",
	"./racecourse-scottsville-turf-inner-1600.svg": "6bb2",
	"./racecourse-scottsville-turf-inner-1750.svg": "e52d",
	"./racecourse-scottsville-turf-inner-1950.svg": "5bb5",
	"./racecourse-scottsville-turf-inner-2000.svg": "c900",
	"./racecourse-scottsville-turf-inner-2400.svg": "5547",
	"./racecourse-scottsville-turf-inner.svg": "21df",
	"./racecourse-scottsville-turf-standside-1000.svg": "301c",
	"./racecourse-scottsville-turf-standside-1100.svg": "78d0",
	"./racecourse-scottsville-turf-standside-1200.svg": "e216",
	"./racecourse-scottsville-turf-standside-1400.svg": "aa6c",
	"./racecourse-scottsville-turf-standside-1500.svg": "9698",
	"./racecourse-scottsville-turf-standside-1600.svg": "91c4",
	"./racecourse-scottsville-turf-standside-1700.svg": "68c4",
	"./racecourse-scottsville-turf-standside-1750.svg": "11db",
	"./racecourse-scottsville-turf-standside-1950.svg": "7f69",
	"./racecourse-scottsville-turf-standside-2000.svg": "b127",
	"./racecourse-scottsville-turf-standside-2400.svg": "b943",
	"./racecourse-scottsville-turf-standside-800.svg": "0fec",
	"./racecourse-scottsville-turf-standside.svg": "62f1",
	"./racecourse-title-logo-hollywoodbets-durbanville-black.svg": "767e",
	"./racecourse-title-logo-hollywoodbets-durbanville-white.svg": "3dce",
	"./racecourse-title-logo-hollywoodbets-greyville-black.svg": "4a6c",
	"./racecourse-title-logo-hollywoodbets-greyville-white.svg": "1f7c",
	"./racecourse-title-logo-hollywoodbets-kenilworth-black.svg": "c15b",
	"./racecourse-title-logo-hollywoodbets-kenilworth-white.svg": "0da6",
	"./racecourse-title-logo-hollywoodbets-scottsville-black.svg": "e7899",
	"./racecourse-title-logo-hollywoodbets-scottsville-white.svg": "754d",
	"./racecourse-turffontein-turf-inner-1000.svg": "f3c4",
	"./racecourse-turffontein-turf-inner-1100.svg": "7bcd",
	"./racecourse-turffontein-turf-inner-1160.svg": "bff8",
	"./racecourse-turffontein-turf-inner-1200.svg": "5ad2",
	"./racecourse-turffontein-turf-inner-1450.svg": "fe18",
	"./racecourse-turffontein-turf-inner-1475.svg": "f10c",
	"./racecourse-turffontein-turf-inner-1500.svg": "cbbc",
	"./racecourse-turffontein-turf-inner-1600.svg": "7c53",
	"./racecourse-turffontein-turf-inner-1700.svg": "cd3f",
	"./racecourse-turffontein-turf-inner-1800.svg": "9ae7",
	"./racecourse-turffontein-turf-inner-1950.svg": "b135",
	"./racecourse-turffontein-turf-inner-2000.svg": "4f25",
	"./racecourse-turffontein-turf-inner-2200.svg": "ae58",
	"./racecourse-turffontein-turf-inner-2400.svg": "c5d9",
	"./racecourse-turffontein-turf-inner-2600.svg": "f3bb",
	"./racecourse-turffontein-turf-inner-3000.svg": "4143",
	"./racecourse-turffontein-turf-inner-800.svg": "48cb",
	"./racecourse-turffontein-turf-inner.svg": "09e7",
	"./racecourse-turffontein-turf-standside-1000.svg": "b14a",
	"./racecourse-turffontein-turf-standside-1100.svg": "098c",
	"./racecourse-turffontein-turf-standside-1160.svg": "0a04",
	"./racecourse-turffontein-turf-standside-1200.svg": "4364",
	"./racecourse-turffontein-turf-standside-1400.svg": "eb9b",
	"./racecourse-turffontein-turf-standside-1600.svg": "82de",
	"./racecourse-turffontein-turf-standside-1800.svg": "107c",
	"./racecourse-turffontein-turf-standside-1950.svg": "aa43",
	"./racecourse-turffontein-turf-standside-2000.svg": "724c",
	"./racecourse-turffontein-turf-standside-2400.svg": "a164",
	"./racecourse-turffontein-turf-standside-2450.svg": "55478",
	"./racecourse-turffontein-turf-standside-2850.svg": "c9a3",
	"./racecourse-turffontein-turf-standside-3200.svg": "7e7b",
	"./racecourse-turffontein-turf-standside-800.svg": "5a41",
	"./racecourse-turffontein-turf-standside.svg": "63e7",
	"./racecourse-vaal-turf-1000.svg": "9608",
	"./racecourse-vaal-turf-1100.svg": "32b0",
	"./racecourse-vaal-turf-1200.svg": "6901",
	"./racecourse-vaal-turf-1300.svg": "aef9",
	"./racecourse-vaal-turf-1400.svg": "5fcf",
	"./racecourse-vaal-turf-1450.svg": "d7eb",
	"./racecourse-vaal-turf-1475.svg": "9ad9",
	"./racecourse-vaal-turf-1500.svg": "8fe2",
	"./racecourse-vaal-turf-1600.svg": "5453",
	"./racecourse-vaal-turf-1700.svg": "0d57",
	"./racecourse-vaal-turf-1800.svg": "b6a2",
	"./racecourse-vaal-turf-2000.svg": "e3b8",
	"./racecourse-vaal-turf-2200.svg": "b55e",
	"./racecourse-vaal-turf-2400.svg": "f03f",
	"./racecourse-vaal-turf-2600.svg": "c533",
	"./racecourse-vaal-turf-2800.svg": "911d",
	"./racecourse-vaal-turf-800.svg": "78a2",
	"./racecourse-vaal-turf-classic-1000.svg": "922c",
	"./racecourse-vaal-turf-classic-1100.svg": "c6df",
	"./racecourse-vaal-turf-classic-1200.svg": "72f2",
	"./racecourse-vaal-turf-classic-1300.svg": "bd75",
	"./racecourse-vaal-turf-classic-1400.svg": "0ac4",
	"./racecourse-vaal-turf-classic-1450.svg": "44a6",
	"./racecourse-vaal-turf-classic-1475.svg": "e929",
	"./racecourse-vaal-turf-classic-1500.svg": "2843",
	"./racecourse-vaal-turf-classic-1600.svg": "42b9",
	"./racecourse-vaal-turf-classic-1700.svg": "7c33",
	"./racecourse-vaal-turf-classic-1800.svg": "b1f7",
	"./racecourse-vaal-turf-classic-2000.svg": "94e4",
	"./racecourse-vaal-turf-classic-2200.svg": "6c98",
	"./racecourse-vaal-turf-classic-2400.svg": "8eb6",
	"./racecourse-vaal-turf-classic-2600.svg": "651f",
	"./racecourse-vaal-turf-classic-2800.svg": "904f",
	"./racecourse-vaal-turf-classic-800.svg": "f628",
	"./racecourse-vaal-turf-classic.svg": "15d2",
	"./racecourse-vaal-turf-inner-1000.svg": "2c7f",
	"./racecourse-vaal-turf-inner-1200.svg": "f443",
	"./racecourse-vaal-turf-inner-1400.svg": "5b47",
	"./racecourse-vaal-turf-inner-1450.svg": "493f",
	"./racecourse-vaal-turf-inner-1500.svg": "92e8",
	"./racecourse-vaal-turf-inner-1600.svg": "0402",
	"./racecourse-vaal-turf-inner-1700.svg": "f7e1",
	"./racecourse-vaal-turf-inner-1800.svg": "195f",
	"./racecourse-vaal-turf-inner-2000.svg": "18fd",
	"./racecourse-vaal-turf-inner-2400.svg": "77f3",
	"./racecourse-vaal-turf-inner-800.svg": "6b9d",
	"./racecourse-vaal-turf-inner.svg": "7f15",
	"./racecourse-vaal-turf.svg": "b60c",
	"./racecourse_mauritius-turf.svg": "62d3",
	"./racetrack-borrowdalePark-turf.svg": "2bf6",
	"./racetrack-durbanville-turf.svg": "0e3e",
	"./racetrack-fairview-poly.svg": "0631",
	"./racetrack-fairview-turf.svg": "c545",
	"./racetrack-flamingoPark-sand.svg": "6140",
	"./racetrack-greyville-poly.svg": "24e1",
	"./racetrack-greyville-turf.svg": "bf63",
	"./racetrack-kenilworth-turf.svg": "a072",
	"./racetrack-mauritius-turf.svg": "cead",
	"./racetrack-scottsville-turf-inner.svg": "1c34",
	"./racetrack-scottsville-turf-standside.svg": "6509",
	"./racetrack-turffontein-turf-inner.svg": "fce4",
	"./racetrack-turffontein-turf-standside.svg": "585d",
	"./racetrack-vaal-turf-classic.svg": "df63",
	"./racetrack-vaal-turf.svg": "e041",
	"./results-icon.svg": "3e02",
	"./sa-flag-icon.svg": "5ca6",
	"./saddle-cloths-1.svg": "f057",
	"./saddle-cloths-10.svg": "9609",
	"./saddle-cloths-11.svg": "c291",
	"./saddle-cloths-12.svg": "8380",
	"./saddle-cloths-13.svg": "7e02",
	"./saddle-cloths-14.svg": "1320",
	"./saddle-cloths-15.svg": "8a01",
	"./saddle-cloths-16.svg": "fce0",
	"./saddle-cloths-17.svg": "8233",
	"./saddle-cloths-18.svg": "812f",
	"./saddle-cloths-19.svg": "fcb1",
	"./saddle-cloths-2.svg": "0e94",
	"./saddle-cloths-20.svg": "7621",
	"./saddle-cloths-3.svg": "2c46",
	"./saddle-cloths-4.svg": "ee7f",
	"./saddle-cloths-5.svg": "dd86",
	"./saddle-cloths-6.svg": "c3ef",
	"./saddle-cloths-7.svg": "1877",
	"./saddle-cloths-8.svg": "f395",
	"./saddle-cloths-9.svg": "584a",
	"./site-selection-new.svg": "961c",
	"./site-selection-old.svg": "0b3d",
	"./sporting-post.svg": "5fbe",
	"./star-icon.svg": "f6d6",
	"./star_punter-icon.svg": "1f65",
	"./statistics-icon.svg": "e71e",
	"./stats-national-jockey-header.jpg": "fea6",
	"./stats-national-trainer-header.jpg": "3601",
	"./trophy-icon.svg": "210a",
	"./twitter-icon.svg": "cc3c",
	"./uk-flag-icon.svg": "c462",
	"./wf-background.jpg": "2e1a",
	"./wf-finishing-position-1.svg": "e189",
	"./wf-finishing-position-10.svg": "9253",
	"./wf-finishing-position-11.svg": "1e8e",
	"./wf-finishing-position-12.svg": "5388",
	"./wf-finishing-position-13.svg": "d45a",
	"./wf-finishing-position-14.svg": "7666",
	"./wf-finishing-position-15.svg": "e4bc",
	"./wf-finishing-position-16.svg": "06bb",
	"./wf-finishing-position-17.svg": "6211",
	"./wf-finishing-position-18.svg": "d26b",
	"./wf-finishing-position-19.svg": "444f",
	"./wf-finishing-position-2.svg": "8dcd",
	"./wf-finishing-position-20.svg": "aeca",
	"./wf-finishing-position-21.svg": "9c58",
	"./wf-finishing-position-22.svg": "9263",
	"./wf-finishing-position-23.svg": "24f4",
	"./wf-finishing-position-24.svg": "c1da",
	"./wf-finishing-position-25.svg": "e647",
	"./wf-finishing-position-26.svg": "6a60",
	"./wf-finishing-position-27.svg": "3e0f",
	"./wf-finishing-position-28.svg": "fa8a",
	"./wf-finishing-position-29.svg": "fb58",
	"./wf-finishing-position-3.svg": "3fc4",
	"./wf-finishing-position-30.svg": "6afc",
	"./wf-finishing-position-4.svg": "9ce0",
	"./wf-finishing-position-5.svg": "3be8",
	"./wf-finishing-position-6.svg": "27f0",
	"./wf-finishing-position-7.svg": "ebe7",
	"./wf-finishing-position-8.svg": "6b36",
	"./wf-finishing-position-9.svg": "69db",
	"./wf-loading-horse.gif": "923a",
	"./white-arrow-back.svg": "e23e",
	"./winning_form-logo_black.png": "b2f7",
	"./winning_form-logo_black1.svg": "d278",
	"./winning_form-logo_black2.svg": "f587",
	"./winning_form-logo_white.svg": "3d5f",
	"./winning_form-logo_white1.svg": "0102"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";